import { IProfile, IOrganization } from '../../../interfaces/graph-types';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { ProfileService } from '../../../services/profile.service';
import { OrganizationService } from '../../../services/organization.service';
import { Observable } from 'rxjs';
import { GlobalWindow } from '../../../main.window';

declare let window: GlobalWindow;

@Component({
  selector: '[organization-navbar]',
  template: require('./organization-navbar.component.pug'),
  styles: [require('./organization-navbar.component.css').toString()],
  //  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationNavbarComponent implements OnInit {
  profile$: Observable<IProfile>;

  currentOrga: IOrganization;
  orgsub: any = null;

  mycss = './organization-navbar.component.scss';

  // -------------------------------------------------------------------
  constructor(
    private org_service: OrganizationService,
    private profileservice: ProfileService,
    private cdr: ChangeDetectorRef,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.orgsub = this.org_service.organization().subscribe(response => {
      this.currentOrga = response;
      // this.cdr.detectChanges();
    });

    this.profile$ = this.profileservice.profile(42);
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {
    if (this.orgsub) {
      this.orgsub.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  brandClass() {
    let newClass = {};

    newClass['brand-' + window.env] = true;

    return newClass;
  }
}
